import { RelatedEntityTypeEnum } from '@/types/schema';

import AddTaskModalProvider from './components/AddTaskModalProvider';
import TaskListModal from './components/TaskListModal';

interface AddTasksModalProps {
  onClose: () => void;
  entityId?: string;
  entity?: RelatedEntityTypeEnum;
  onSubmit: (refetchData?: boolean) => void;
}

function AddTasksModal(props: AddTasksModalProps) {
  const { onClose, entity, entityId, onSubmit } = props;

  return (
    <AddTaskModalProvider>
      <TaskListModal
        entityId={entityId}
        entityType={entity}
        onClose={onClose}
        onSubmit={onSubmit}
      />
    </AddTaskModalProvider>
  );
}

export default AddTasksModal;
